// extracted by mini-css-extract-plugin
export default {"productsList":"productsList_productsList__7Y75l","not-found":"productsList_not-found__-2T+Q"};